import React from 'react';

function PrivacyPolicy() {
  return (
    <div
      style={{
        display: 'flex',
        width: '80vw',
        flexDirection: 'column',
        alignSelf: 'center',
      }}
    >
      <h2 style={{ margin: '0px 0px', marginTop: 20 }}>
        Privacy and Cookies Policy
      </h2>
      <h4 style={{ color: 'red', margin: '0px 0px', marginTop: 5 }}>
        Effective Date: 26/07/2026
      </h4>
      <div>
        <ol>
          <li>
            <b>Who are we?</b>
            <ol>
              <li>
                We are Eurointelligence Limited, a company incorporated in
                England and Wales under company number 5778200, trading as
                “Eurointelligence”. Our registered office is at The Wheelhouse
                Angel Court, 81 St Clements Street, Oxford OX4 1AW, United
                Kingdom.
              </li>
              <li>
                For queries in relation to your privacy and our use of cookies,
                you can contact us at privacy@eurointelligence.com.
              </li>
            </ol>
          </li>
          <li>
            <b>What’s the point of this policy?</b>
            <ol>
              <li>
                It tells you what to expect when we collect your personal data.
                Please only use our website and services if you are completely
                happy with this policy.
              </li>
              <li>
                To make sure you have a full picture of how we collect and use
                your personal data, this policy describes:{' '}
                <ol>
                  <li>
                    who is responsible for the personal data that we collect
                    about you;
                  </li>
                  <li>the personal data we collect about you;</li>
                  <li>how we will use it;</li>
                  <li>who we may disclose it to; and</li>
                  <li>
                    your rights and choices in relation to your personal data.
                  </li>
                </ol>
              </li>
              <li>
                Generally, this policy covers only information provided to us.
                If you give personal data to other people, such as by visiting
                any websites linked to from our website or choosing to pay for
                your subscription for our services using a third payment service
                (we currently use PayPal and Stripe) those third parties will
                separately process your personal data in order for you to use
                their service. Data shared with third parties will be processed
                in accordance with their privacy policies and we recommend you
                review the information in those notices before you share any
                personal data or use their payment service.
              </li>
            </ol>
          </li>
          <li>
            <b>Might the policy change?</b>
            <ol>
              <li>
                Yes. Please check whenever you visit our website. We will assume
                you agree to the new version of the policy if you use the
                website after its effective date. We will generally notify you
                or otherwise draw your attention to any material changes.
              </li>
            </ol>
          </li>
          <li>
            <b>Who is responsible for the personal data that we collect?</b>
            <ol>
              <li>
                We are the data controller for the purpose of data protection
                law, in respect of your personal data collected and used through
                your use of the website and our services.&nbsp; This is because
                we determine the purpose for which your personal data is used
                and how we use your personal data.
              </li>
            </ol>
          </li>
          <li>
            <b>What do we collect?</b>
            <ol>
              <li>
                Information which you or the entity subscribing to our services
                provides to us in order for you and the entity to receive the
                benefit of our services, such as your name, email address,
                postal address and telephone number, as well as any other
                information provided to us by email or by completing the form to
                contact us on our website.
              </li>
              <li>
                Automated information such as the internet protocol (IP) address
                used to connect your device to the internet and access our
                website, connection information such as browser type and
                version, information about your device including device-type and
                device identifier, operating system and platform, mobile network
                data, a unique reference number linked to the data you enter on
                our system, login details, the website from which you arrived at
                our service, details of your activity with date/time stamps
                including pages you visited and your searches/transactions.
              </li>
              <li>
                We do not collect any&nbsp;
                <b>Special Categories of Personal Data</b>&nbsp;about you (this
                includes details about your race or ethnicity, religious or
                philosophical beliefs, sex life, sexual orientation, political
                opinions, trade union membership, information about your health,
                and genetic and biometric data). Nor do we collect any
                information about criminal convictions and offences.
              </li>
            </ol>
          </li>
          <li>
            <b>What’s our reason/legal basis for collecting the information?</b>
            <ol>
              <li>
                We use and retain this information:{' '}
                <ol>
                  <li>
                    where you subscribe to our services, as it is necessary to
                    enter into or perform the contract we have with you (or to
                    take steps at your request prior to entering into that
                    contract);
                  </li>
                  <li>
                    where you benefit from our services due to your connection
                    with an entity subscribing to our services, as it is in our
                    legitimate interests to process your personal data in order
                    to provide our services; and
                  </li>
                  <li>
                    where you use our website or contact us by email or through
                    the form on our website, and the retention does not fall
                    within (a) above, as it is in our legitimate interests to
                    process your personal data to allow us to reply to you and
                    to help us to provide you with a good experience when you
                    browse our website and make improvements to improve our
                    services.
                  </li>
                </ol>
              </li>
              <li>
                We may also use your data where we are subject to a legal
                obligation or in order to take legal action to enforce the terms
                of any contract entered into with you or contractual notices to
                which you are subject.
              </li>
              <li>
                If we are entitled to send you marketing materials and you have
                not objected to this, we may send you email marketing from time
                to time. For business customers, it is within our legitimate
                interests to send you marketing communications. If you are an
                individual, we rely on soft opt-in consent. You will have the
                opportunity to opt-out of use of your data for marketing
                purposes when we first collect your data and via an unsubscribe
                function within each communication.
              </li>
            </ol>
          </li>
          <li>
            <b>What about cookies?</b>
            <ol>
              <li>
                We and/or third parties use cookies and similar technologies
                (such as browser local storage) on our website. A cookie is an
                identifier (a small file of letters and numbers) that is sent to
                your computer. Our website’s functionality will be limited if
                you configure your browser to reject cookies.
              </li>
              <li>
                Cookies are widely used to make websites work, or work more
                efficiently, as well as to provide information to the website
                owner or others. Session cookies are temporary cookies that
                remain in the cookie file of your browser only until your
                browser is closed. They allow websites to link your actions
                during a browser session. Persistent cookies stay in the cookie
                file of your browser for longer (how long will depend on the
                lifetime of the specific cookie). For further information on
                cookies, including how to use your browser to block them and how
                to delete cookies already stored on your device, visit:{' '}
                <a
                  href='http://www.allaboutcookies.org'
                  target='_blank'
                  rel='noreferrer'
                >
                  www.allaboutcookies.org
                </a>
                .
              </li>
              <li>
                The following cookies and similar technologies are used on this
                website:{' '}
                <ol>
                  <li>
                    <b>
                      <i>Essential login storage:</i>
                    </b>{' '}
                    When you sign in, we store your email address in your
                    browser’s local storage (a technology similar to cookies) so
                    that you stay signed in between visits. This is essential
                    for the service and remains until you log out or clear your
                    browser data.
                  </li>
                  <li>
                    <b>
                      <i>Payment cookies (Stripe):</i>
                    </b>{' '}
                    Our payment provider, Stripe, sets cookies when you visit
                    our subscription page in order to process payments securely
                    and to prevent fraud (for example __stripe_mid, kept for up
                    to one year, and __stripe_sid, kept for around 30 minutes).
                    You can find more information in{' '}
                    <a
                      href='https://stripe.com/legal/cookies-policy'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Stripe’s cookie policy
                    </a>
                    .
                  </li>
                  <li>
                    We do not currently use analytics cookies (such as Google
                    Analytics) or advertising cookies on our website.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <b>What do we do with personal data?</b>
            <ol>
              <li>
                Provide our services, e.g. send service messages, process
                payments, fulfil orders.
              </li>
              <li>
                Use it to recognise you when you visit or return to our service,
                when you log into any secure area of our website, to track
                anonymised traffic and usage patterns, prevent or detect fraud
                or abuses and help us improve our service.
              </li>
            </ol>
          </li>
          <li>
            <b>How long do we keep it?</b>
            <ol>
              <li>
                Where you subscribe to our service or receive the service to
                your email address due to your connection with a subscribing
                entity, we will generally keep your information for up to six
                years after your account is closed for tax reasons and/or to
                help deal with any disputes. We retain your information received
                for other purposes for 7 years. These timeframe may vary if we
                are legally required to keep information for a particular
                period. Every year we go through our systems to delete all those
                that no longer need to be in our database.
              </li>
            </ol>
          </li>
          <li>
            <b>To whom do we send or make available your personal data?</b>
            <ol>
              <li>
                To other people who supply us with a service and who process
                data on our behalf e.g. e-commerce platform providers, database
                services, website hosts, content delivery networks and
                businesses which help us send communications or monitor our
                website. We use Google Cloud Platform (Cloud Functions,
                Firestore, Firebase Hosting) for website infrastructure and
                content. Our accounting software is Xero, where we use your name
                and email for invoicing purposes. We require them to respect the
                security of your personal data and to treat it in accordance
                with the law. We do not allow our third-party service providers
                to use your personal data for their own purposes and only permit
                them to process your personal data for specified purposes and in
                accordance with our instructions
              </li>
              <li>
                To the police or other relevant authorities or to complainants,
                if we think the personal data breaches our terms and conditions,
                or it is necessary to protect us or others, or that a criminal
                offence may have been committed, or where required by law or
                where requested by the police or other appropriate authorities.
              </li>
              <li>
                To third parties if we are under a duty to disclose or share
                your personal data in order to comply with any legal obligation
                or instructions of a regulatory body (including in connection
                with a court order).
              </li>
              <li>
                To other third parties in order to enforce or apply the terms of
                any agreements we have with or otherwise concerning you
                (including agreements between you and us) or to protect our
                rights, property or safety of our customers, employees or other
                third parties.
              </li>
              <li>
                To our professional advisors (including accountants, lawyers and
                auditors) that assist us in carrying out our business
                activities.
              </li>
              <li>
                To potential buyers so far as reasonably necessary, in the case
                of an actual or proposed (including negotiations for a) sale or
                merger or business combination involving all or the relevant
                part of our business.
              </li>
            </ol>
          </li>
          <li>
            <b>What happens to your payment details?</b>
            <ol>
              <li>
                These go direct to our payment partners. We do not receive such
                information except as stated above. To ensure your details are
                not being used without consent, our payment partners may send
                your personal data to relevant third parties including credit
                reference and fraud prevention agencies, who may keep a record
                of that information.
              </li>
            </ol>
          </li>
          <li>
            <b>Do we send your information outside the European Union?</b>
            <ol>
              <li>
                Your personal data which we collect is stored within the UK and
                EU and is not transferred to any third countries except for the
                following:
              </li>
              <li>
                Your personal data may be transferred to the US by the following
                companies as we have agreements in place providing certain
                safeguards for your personal data: Google Cloud Platform
                (website login, customer database), Amazon (mailbox hosting),
                Xero (invoicing), Stripe (payments).
              </li>
            </ol>
          </li>
          <li>
            <b>What about high-risk processing?</b>
            <ol>
              <li>
                We will conduct a Data Protection Impact Assessment (DPIA)
                before starting any high-risk data processing. This is to help
                us find, evaluate, and lower privacy risks to protect your
                personal information.
              </li>
            </ol>
          </li>
          <li>
            <b>What rights do you have?</b>
            <ol>
              <li>
                You have certain rights with respect to your personal
                information.&nbsp; The rights may only apply in certain
                circumstances and are subject to certain exemptions.&nbsp;
              </li>
              <li>
                We keep your data for 7 years for tax purposes and in accordance
                to UK GDPR terms.
              </li>
              <li>
                Please see the table below for a summary of your rights.&nbsp;
                You can exercise these rights by emailing us at{' '}
                <a href='mailto:privacy@eurointelligence.com'>
                  privacy@eurointelligence.com
                </a>
                .&nbsp;
              </li>
            </ol>
          </li>
        </ol>
        <table>
          <tbody>
            <tr>
              <td>
                <p>&nbsp;</p>
              </td>
              <td>
                <p>
                  <b>Summary of your rights</b>
                </p>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>
                <p>
                  <b>Right of access to your personal information</b>
                </p>
              </td>
              <td>
                <p>
                  You have the right to receive a copy of your personal
                  information that we hold about you, subject to certain
                  exemptions.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  <b>Right to rectify your personal information</b>
                </p>
              </td>
              <td>
                <p>
                  You have the right to ask us to correct your personal
                  information that we hold where it is incorrect or incomplete.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  <b>Right to erasure of your personal information</b>
                </p>
              </td>
              <td>
                <p>
                  You have the right to ask that your personal information be
                  deleted in certain circumstances. For example:
                </p>
                <ul>
                  <li>
                    <p>
                      where your personal information is no longer necessary in
                      relation to the purposes for which it was collected or
                      otherwise used;
                    </p>
                  </li>
                  <li>
                    <p>
                      if you withdraw your consent and there is no other legal
                      ground for which we rely on for the continued use of your
                      personal information;
                    </p>
                  </li>
                  <li>
                    <p>
                      if you object to the use of your personal information (as
                      set out below);
                    </p>
                  </li>
                  <li>
                    <p>
                      if we have used your personal information unlawfully; or
                    </p>
                  </li>
                  <li>
                    <p>
                      if your personal information needs to be erased to comply
                      with a legal obligation.
                    </p>
                  </li>
                </ul>
                &nbsp;
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  <b>Right to restrict the use of your personal information</b>
                </p>
              </td>
              <td>
                <p>
                  You have the right to suspend our use of your personal
                  information in certain circumstances. For example:
                </p>
                <ul>
                  <li>
                    <p>
                      where you think your personal information is inaccurate
                      but only for so long as is required for us to verify the
                      accuracy of your personal information;
                    </p>
                  </li>
                  <li>
                    <p>
                      the use of your personal information is unlawful and you
                      oppose the erasure of your personal information and
                      request that it is suspended instead;
                    </p>
                  </li>
                  <li>
                    <p>
                      we no longer need your personal information, but your
                      personal information is required by you for the
                      establishment, exercise or defence of legal claims; or
                    </p>
                  </li>
                  <li>
                    <p>
                      you have objected to the use of your personal information
                      and we are verifying whether our grounds for the use of
                      your personal information override your objection.
                    </p>
                  </li>
                </ul>
                &nbsp;
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  <b>Right to data portability</b>
                </p>
              </td>
              <td>
                <p>
                  You have the right to obtain your personal information in a
                  structured, commonly used and machine-readable format and for
                  it to be transferred to another organisation, where it is
                  technically feasible.
                </p>
                <p>The right only applies:</p>
                <ul>
                  <li>
                    <p>to personal information you provided to us;</p>
                  </li>
                  <li>
                    <p>where we rely on the following legal bases:</p>
                  </li>
                  <li>
                    <p>consent; or</p>
                  </li>
                  <li>
                    <p>for the performance of a contract; and</p>
                  </li>
                  <li>
                    <p>
                      when the use of your personal information is carried out
                      by automated (i.e. electronic) means.
                    </p>
                  </li>
                </ul>
                &nbsp;
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  <b>Right to object to the use of your personal information</b>
                </p>
              </td>
              <td>
                <p>
                  You have the right to object to the use of your personal
                  information in certain circumstances and subject to certain
                  exemptions. For example:
                </p>
                <ul>
                  <li>
                    <p>
                      where you have grounds relating to your particular
                      situation and we use your personal information for our
                      legitimate interests (or those of a third party); or
                    </p>
                  </li>
                </ul>
                <p>&nbsp;</p>
                <ul>
                  <li>
                    <p>
                      if you object to the use of your personal information for
                      direct marketing purposes.
                    </p>
                  </li>
                </ul>
                &nbsp;
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  <b>Right to withdraw consent</b>
                </p>
              </td>
              <td>
                <p>
                  You have the right to withdraw your consent at any time where
                  we rely on consent to use your personal information.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  <b>
                    Right to complain to the relevant data protection authority
                  </b>
                </p>
              </td>
              <td>
                <p>
                  You have the right to complain to the relevant data protection
                  authority, which is the Information Commissioner's Office,
                  where you think we have not used your personal information in
                  accordance with data protection law.
                </p>
                <p>
                  You can contact them on 0303 123 1113, go online to
                  www.ico.org.uk/concerns. or write to them at:
                </p>
                <p>Information Commissioner's Office</p>
                <p>Wycliff House</p>
                <p>Water Lane</p>
                <p>Wilmslow</p>
                <p>Cheshire</p>
                <p>SK9 5AF</p>
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          13.4 For more information about your rights, visit the ICO’s website:
          www.ico.org.uk. &nbsp;
        </p>
        <p>
          Version:<b>3</b>
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
